// extracted by mini-css-extract-plugin
export var discountText = "flashSale-module--discountText--Jv-Px";
export var discountValue = "flashSale-module--discountValue--YPpp-";
export var flashSaleIcon = "flashSale-module--flashSaleIcon--9DnqI";
export var flashSaleText = "flashSale-module--flashSaleText--o3dPr";
export var flashSaleWrapper = "flashSale-module--flashSaleWrapper--bKm+W";